import script from "./NoteFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteFilter.vue?vue&type=script&setup=true&lang=js"

import "./NoteFilter.vue?vue&type=style&index=0&id=3f253f7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f253f7b"]])

export default __exports__